import useTranslation from "next-translate/useTranslation";
import { HomeMetricCardV2 as DashboardCard } from "components/ui/v2";

interface IKPIOrgCareersProps {
  loading?: boolean;
  careersCompleted: [number, number];
  actionPlansCompleted: [number, number];
  performance: number;
}

const KPIOrgCareers = (props: IKPIOrgCareersProps) => {
  const { careersCompleted, actionPlansCompleted, performance, loading } =
    props;
  const { t } = useTranslation("common");

  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
      <DashboardCard
        title={t("Planes de carrera completados")}
        value={careersCompleted[0] || 0}
        refValue={careersCompleted[1] || 0}
        loading={loading}
        popupInfo={t(
          "Son los planes de carrera que a la fecha de la consulta han logrado el 100% de cumplimiento"
        )}
      />
      <DashboardCard
        title={t("Planes de acción completados")}
        value={actionPlansCompleted[0]}
        refValue={actionPlansCompleted[1]}
        loading={loading}
        popupInfo={t(
          "Son todos los planes de acción que fueron asignados a las personas y que las personas cumplieron (Estado del plan de acción = Logrado)"
        )}
      />
      <DashboardCard
        title={t("Adherencia a los planes")}
        value={performance}
        percent
        loading={loading}
        popupInfo={t(
          "Cantidad total de planes creados y asignados / planes logrados"
        )}
      />
    </div>
  );
};

export default KPIOrgCareers;
